export default __webpack_public_path__ + "images/a201f20c41dfbd51ec138d906c94366f-inv-exp-hover-icon.svg";